export const fontFamily = {
  primary: 'Hellix',
  secondary: 'Space Grotesk',
};

export const fontWeight = {
  normal: '500',
  bold: '600',
};
